module.exports = __webpack_public_path__ + "img/pic_button_suspend_active_en@2x.5c1f70a5.png";